module.exports = __webpack_public_path__ + "img/redirect-url.88dbed9e.png";